import type { Recipe, RecipeStep } from "~/types/models";

function parseStepCandidate(candidate: unknown, index: number): RecipeStep {
  const step = candidate as Partial<RecipeStep>;
  return {
    id: step.id ?? String(index + 1),
    title: step.title ?? `Step ${index + 1}`,
    description: step.description ?? "",
    waitMinutes: Number.isFinite(Number(step.waitMinutes))
      ? Number(step.waitMinutes)
      : 0,
    type: step.type === "wait" ? "wait" : "active",
  };
}

export function parseRecipeSteps(recipe: Recipe): RecipeStep[] {
  if (recipe.steps) {
    try {
      const parsed = JSON.parse(recipe.steps) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.map(parseStepCandidate);
      }
    } catch (error) {
      console.warn(
        "[parseRecipeSteps] Failed to parse steps JSON for recipe, falling back to instructions:",
        error,
      );
    }
  }

  return recipe.instructions
    ? recipe.instructions
        .split("\n")
        .filter(Boolean)
        .map((text, i) => ({
          id: String(i + 1),
          title: text.length > 60 ? `${text.slice(0, 57)}…` : text,
          description: text,
          waitMinutes: 0,
          type: "active" as const,
        }))
    : [];
}
